module.exports = __webpack_public_path__ + "img/STP.4b2248c2.svg";